import * as Klaro from "klaro/dist/klaro-no-css";
window.klaro = Klaro;

import '../Fusion/Component/Atom/ConsentSettingsButton/ConsentSettingsButton';
import '../Fusion/Component/Atom/NoConsentPlaceholder/NoConsentPlaceholder';
import '../Styles/Consent.scss';
